// Avatar por defecto en base64 para evitar peticiones HTTP
export const DEFAULT_AVATAR_BASE64 = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iMzciIHI9IjE4IiBmaWxsPSIjOUNBM0FGIi8+CjxwYXRoIGQ9Ik0yMCA4NUMyMCA3My45NTQzIDI4Ljk1NDMgNjUgNDAgNjVINjBDNzEuMDQ1NyA2NSA4MCA3My45NTQzIDgwIDg1VjEwMEgyMFY4NVoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+';

export const getDefaultAvatar = (): string => {
  return DEFAULT_AVATAR_BASE64;
};
